import { render, staticRenderFns } from "./PlayersContent.vue?vue&type=template&id=f5ce8d50&scoped=true&"
import script from "./PlayersContent.vue?vue&type=script&lang=ts&"
export * from "./PlayersContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ce8d50",
  null
  
)

export default component.exports